
<script>
  export default {
    mounted () {
      this.$bus.$on('sweet-erro', obj => {
        const { message } = obj
        this.$swal({
          title: 'Ops, encontramos um erro!',
          html: message,
          type: 'error',
          cancelButtonText: 'Ok'
        })
      })
    }
  }
</script>

<template>
  <div></div>
</template>



// WEBPACK FOOTER //
// src/components/sweet-erro.vue